import { dateParser } from './dateParser';
import { useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import { Regions } from './regions';

export const Market = {

    update: (callback) => {
        const app = useSelector((state) => state.app);
        if (app.updated) {
            return;
        }

        axios.get(app.updateURL)
        .then(function (response) {
            callback(response.data);
        })
        .catch(function (error) {
            console.log(error);
        });
    },

    getData: () => {
        const app = useSelector((state) => state.app);
        const region = Regions.getRegionByCode(app.region);
        if (!region) {
            return [];
        }
        const markets = region.markets;
        if (!markets) {
            return [];
        }
        
        let result = [];
        markets.forEach(market => {
            const dateObject = moment(Market.getDateNext(market, app.selectedDate));
            if (dateObject.isSame(app.selectedDate, 'month')) {
                result.push({
                    ...market,
                    nextDate: dateObject,
                    nextDateText: dateObject.format('dddd DD.MM.YYYY'),
                    past: dateObject.isBefore(moment(), 'day'),
                    future: dateObject.isAfter(moment(), 'day'),
                    today: dateObject.isSame(moment(), 'day'),
                    video: Market.getVideo(market, dateObject)
                });
            }
        });

        result = result.sort((a, b) => {
            return a.nextDate.diff(b.nextDate, 'days');
        });
        return result;
    },

    getDateNext: (market, currentDate) => {
        if (market.repeat) {
            return dateParser.parse(market.rule, currentDate);
        }
        else if (market.permanent) {
            return currentDate;
        }
        else {
            return moment(market.date);
        }
    },

    getVideo: (market, currentDate) => {
        if (market.videos && market.videos.length) {
            const videos = market.videos.filter((el) => {
                const videoDate = moment(el.date);
                return videoDate.isSame(currentDate, 'day');
            });
            return videos.length ? videos[0] : null;
        }
    }
}